


















































































import { AdgroupFormData } from '@tt4b/ttam-enums';
import { i18n } from '@tt4b/ttam-i18n';
import { defineComponent, PropType, ref, computed, toRefs, watch } from '@vue/composition-api';
const name = 'ttam-sidebar-copy-adgroup-dialog';
export default defineComponent({
  name,
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    copyMaxNum: {
      type: Number,
      default: 1,
    },
    copyNumLimitHint: {
      type: String,
      default: i18n.t('flexible_copy_adgroup_copy_number_hint'),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, copyNumLimitHint: copyAdgroupNumLimitHint, copyMaxNum } = toRefs(props);
    const copyMinNum = ref(0);
    const copyForm = ref();
    const inputNumber = ref();
    const isShowNameTemplateTips = ref(false);
    const copyAdgroupNameArr = ref([]);

    const formData = ref({
      copyNumber: 1, // copy  多少份
    });

    const disableCopyBtn = computed(() => copyMaxNum.value <= 0);

    const copyNumLimitAlertVisible = computed(() => props.copyMaxNum === formData.value.copyNumber);

    const currentCopyNumLimitHint = computed(
      () => copyAdgroupNumLimitHint.value || i18n.t('flexible_copy_adgroup_copy_number_hint'),
    );

    const resetCopyForm = () => {
      formData.value.copyNumber = 1;
      copyAdgroupNameArr.value = [];
    };
    const handleClose = () => {
      emit('close');
      resetCopyForm();
    };
    const handleCopyAdgroupNameChange = (val, index) => {
      copyAdgroupNameArr.value[index] = val || '';
      emit('adgroup-name-change', { value: val, index });
    };
    const handleCopyAdgroupNameArr = num => {
      if (num > copyAdgroupNameArr.value.length) {
        for (let i = copyAdgroupNameArr.value.length; i < num; i++) {
          const newName = i18n.t('flexible_copy_title_prefix', {
            Number: i + 1,
            Name: adgroupData.value.name,
          });
          copyAdgroupNameArr.value.push(newName);
        }
      } else if (num < copyAdgroupNameArr.value.length) {
        for (let i = copyAdgroupNameArr.value.length; i > num; i--) {
          copyAdgroupNameArr.value.pop();
        }
      }
    };
    const handleCopyNumberChange = num => {
      if (num <= props.copyMaxNum) {
        handleCopyAdgroupNameArr(num);
        if (copyNumLimitAlertVisible.value) {
          copyNumLimitAlertVisible.value = false;
        }
      } else {
        copyNumLimitAlertVisible.value = true;
      }
      emit('copy-number-change', num);
    };
    const handleOpen = () => {
      handleCopyAdgroupNameArr(formData.value?.copyNumber || 1);
      emit('open');
    };
    const handleCopy = () => {
      emit('click-confirm');
      emit('copy', copyAdgroupNameArr.value);
      handleClose();
    };
    const handleCancel = () => {
      emit('click-cancel');
      handleClose();
    };
    watch(
      copyNumLimitAlertVisible,
      (val, preVal) => {
        if (val !== preVal) {
          emit('copy-numlimit-alert-visible-change', val);
        }
      },
      { immediate: true },
    );
    watch(
      isShowNameTemplateTips,
      (val, preVal) => {
        if (val !== preVal) {
          emit('name-template-alert-visible-change', val);
        }
      },
      { immediate: true },
    );
    return {
      name,
      copyMinNum,
      inputNumber,
      formData,
      copyNumLimitAlertVisible,
      isShowNameTemplateTips,
      copyAdgroupNameArr,
      copyForm,
      currentCopyNumLimitHint,
      disableCopyBtn,
      handleOpen,
      handleClose,
      handleCopyAdgroupNameChange,
      handleCopyNumberChange,
      handleCopy,
      handleCancel,
    };
  },
});
